import { useTranslation } from "next-i18next";

import { StepsDots } from "../StepsDots";
import PaymentTitle from "../PaymentTitle";

import styles from "./PaymentHeader.module.scss";

const PaymentHeader = () => {
  const { t } = useTranslation("translations");

  return (
    <div className={styles.header}>
      <StepsDots activeStep={4} />

      <PaymentTitle>{t("web_payment_header")}</PaymentTitle>
    </div>
  );
};

export default PaymentHeader;
